<template>
  <div class="home-page">
    <!-- 全屏轮播图 -->
    <section class="hero-section">
      <el-carousel height="600px" :interval="10000" arrow="always">
        <el-carousel-item v-for="(slide, index) in carouselSlides" :key="index">
          <div class="carousel-content" :style="{ backgroundImage: `url(${slide.image})` }">
            <div class="overlay"></div>
            <div class="carousel-caption">
              <h2 class="slide-subtitle animate__animated animate__fadeInDown">{{ slide.title }}</h2>
              <h1 class="slide-title animate__animated animate__fadeInUp">{{ slide.subtitle }}</h1>
              <!-- <el-button 
                class="slide-button animate__animated animate__fadeInUp" 
                type="primary" 
                size="large"
                @click="navigateTo(slide.buttonLink)"
              >
                {{ slide.buttonText }}
              </el-button> -->
              <div style="display: flex; align-items: center; justify-content: center; width: 100%;height: auto;">
                <div class="text-wrapper_1" @click="navigateTo(slide.buttonLink)"
                  style="display: flex; flex-direction: row;justify-content: center;align-items: center;">
                  <span class="text_7">{{ slide.buttonText }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- <section class="business-video">
      <div class="bvideos">
        <video autoplay="" loop="" playsinline=""
          src="https://cdn.xidesheng.com/2025/03/24/1742804146092-qaK1742461188290-AvSastn.mp4"></video>
      </div>
    </section> -->

    <!-- 主要业务领域 -->
    <section class="business-areas">
      <div class="page-container">
        <div class="text-group_5">
          <span class="text_8">沃雷顿自行车分类</span>
          <span class="text_9">Wolleyton&nbsp;bicycle&nbsp;classification</span>
          <div class="box_9"></div>
        </div>
        <div class="business-grid">
          <div v-for="(area, index) in businessAreas" :key="index" class="business-card"
            :class="{ active: activeIndex === index }" @click="navigateTo(area.link)" @mouseenter="() => {
              activeIndex = index
            }">
            <!-- :style="`background-image: url('${area.icon}')` "  -->
            <div class="business-icon">
              <img :src="area.icon" alt="自行车背景" width="100%" height="auto" />
            </div>
            <h3>{{ area.title }}</h3>
            <p>{{ area.description }}</p>
            <div class="business-hover">
              <img :src="require('@/assets/images/home/jiantou.png')" :alt="跳转" width="32px" height="32px" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 画册 -->
    <div class="statistics-section">
      <div class="hua-top"></div>
      <div class="carousel-container">
        <div class="text-group_5">
          <span class="text_8" style="color: #fff;">每一次骑行，都藏着鲜花美景和落日长河的无尽魅力</span>
          <span class="text_9" style="color: #fff;">A&nbsp;wonderful&nbsp;cycling&nbsp;experience</span>
          <div class="box_9"></div>
        </div>
        <div class="carousel-wrapper">
          <!-- <div  :class="`carousel-item item${parseInt(index % 5)}`" v-for="(image, index) in images" :key="index">
            <img :src="image" alt="Carousel Image" />
          </div> -->
          <template v-for="(image, index) in images" :key="'front-' + index">
            <div v-if="parseInt(index % 3) === 0" :class="`carousel-item`">
              <img :src="images[index]" alt="Carousel Image" :class="`item${parseInt(index % 6)}`" />
              <img :src="images[index + 1]" alt="Carousel Image" :class="`item${parseInt(index % 6) + 1}`" />
            </div>
            <div v-if="parseInt(index % 6) === 2 || parseInt(index % 6) === 5"
              :class="`carousel-item item${parseInt(index % 6)}`">
              <img :src="image" alt="Carousel Image" />
            </div>
          </template>

          <template v-for="(image, index) in images" :key="'back-' + index">
            <div v-if="parseInt(index % 3) === 0" :class="`carousel-item`">
              <img :src="images[index]" alt="Carousel Image" :class="`item${parseInt(index % 6)}`" />
              <img :src="images[index + 1]" alt="Carousel Image" :class="`item${parseInt(index % 6) + 1}`" />
            </div>
            <div v-if="parseInt(index % 6) === 2 || parseInt(index % 6) === 5"
              :class="`carousel-item item${parseInt(index % 6)}`">
              <img :src="image" alt="Carousel Image" />
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 正在发生 (新闻动态) -->
    <section class="news-section">
      <div class="page-container">
        <div class="text-group_5">
          <span class="text_8">新闻与活动</span>
          <span class="text_9">News&nbsp;and&nbsp;Events</span>
          <div class="box_9"></div>
        </div>

        <div class="news-content">
          <div class="main-news" :class="{ 'slide-in': oldSelect }" v-if="newsList.length > 0">
            <div class="main-news-item" @click="viewNewsDetail(selectedNews._id)">
              <div class="news-image">
                <img :src="selectedNews.cover || require('@/assets/images/news/news-placeholder.jpg')"
                  :alt="selectedNews.title">
              </div>
              <div class="news-info">
                <h3>{{ selectedNews.title }}</h3>
                <p>{{ getSummary(selectedNews.content, 120) }}</p>
                <div class="news-meta">
                  <span class="date">{{ formatDate(selectedNews.editTime) }}</span>
                  <span class="read-more">阅读全文 <i class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>
          <!--  @mouseleave="changeMainNews(newsList[0])" -->
          <div class="sub-news">
            <div v-for="(item, index) in newsList.slice(0, 4)" :key="index" class="sub-news-item"
              @mouseover="changeMainNews(item)">
              <div class="news-info">
                <h3>{{ item.title }}</h3>
                <div class="news-meta">
                  <span class="date">{{ formatDate(item.editTime) }}</span>
                  <span @click="viewNewsDetail(item._id)" class="read-more">阅读全文 <i
                      class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="news-more">
          <router-link to="/news" class="more-link">探索更多 <i class="el-icon-arrow-right"></i></router-link>
        </div>
      </div>
    </section>

    <!-- 公司介绍视频 -->
    <!-- <section class="video-section">
      <div class="page-container">
        <div class="video-container">
          <div class="video-text">
            <h2>开拓新价值 共创新未来</h2>
            <p>沃雷顿自行车致力于为客户提供高品质的软件开发和信息技术服务，帮助企业数字化转型和创新发展</p>
            <router-link to="/about" class="video-link">了解更多 <i class="el-icon-arrow-right"></i></router-link>
          </div>
          <div class="video-player">
            <div class="video-placeholder" @click="playVideo">
              <img src="@/assets/images/logo/logo.png" alt="公司宣传视频">
              <div class="play-button">
                <i class="el-icon-video-play"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->


  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getHotNews } from '@/api/news';
import { getAdvertiseList, getAlbumList, getHomeCate } from '@/api/home';
import { formatDate, getSummary } from '@/utils/helper';
import { getOverview } from '@/api/statistics';
import CountTo from '@/components/CountTo.vue';

export default {
  name: 'HomeView',
  components: {
    CountTo
  },
  setup() {
    const router = useRouter();
    const newsList = ref([]);
    const isLoading = ref(false);
    const statisticsData = ref([]);
    const statisticsLoading = ref(false);
    const activeIndex = ref(0);

    const images = ref([]);

    const imageWidth = 600; // 设置每张图片的宽度


    // 格式化当前时间
    const currentTime = computed(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    });

    // 轮播图数据
    const carouselSlides = ref([]);

    // 业务领域数据
    const businessAreas = ref([
      // {
      //   title: '童车',
      //   description: '车架粗壮结实，能够承受较大的冲击力。',
      //   icon: require('@/assets/images/home/cart1.png'),
      //   link: '/product'
      // },
      // {
      //   title: '公主车',
      //   description: '车架粗壮结实，能够承受较大的冲击力。',
      //   icon: require('@/assets/images/home/cart2.png'),
      //   link: '/product'
      // },
      // {
      //   title: '山地车',
      //   description: '车架粗壮结实，能够承受较大的冲击力。',
      //   icon: require('@/assets/images/home/cart2.png'),
      //   link: '/product'
      // },
      // {
      //   title: '公路车',
      //   description: '车架粗壮结实，能够承受较大的冲击力。',
      //   icon: require('@/assets/images/home/cart2.png'),
      //   link: '/product'
      // }
    ]);

    //获取幻灯片
    const fetchAdvertise = async () => {
      isLoading.value = true;
      const res = await getAdvertiseList({}, { size: 6 });
      if (res && res.data) {
        carouselSlides.value = res.data?.content.map(item => {
          return {
            title: item.title,
            subtitle: item.subtitle,
            buttonText: item.note,
            buttonLink: item.url,
            image: item.pic
          }
        })
      }

    }

    //获取推荐分类
    const fetchHomeCate = async () => {
      const res = await getHomeCate();
      if (res && res.data) {
        businessAreas.value = res.data?.data.map(item => {
          return {
            title: item.name,
            description: item.remark,
            icon: item.icon || require('@/assets/images/home/cart1.png'),
            link: '/products/' + item.id
          }
        })
      }

    }

    //获取幻画册
    const fetchAlbum = async () => {
      const res = await getAlbumList({}, { size: 12 });
      //  console.log("fetchAdvertise",res);
      if (res && res.data) {
        images.value = res.data?.content.map(item => item.showpath);
      }

    }

    // 获取新闻列表
    const fetchNews = async () => {
      isLoading.value = true;
      try {
        const res = await getHotNews({ size: 4 });
        if (res && res.data) {
          newsList.value = res.data?.rows.map(item => {
            return {
              _id: item.noticeId,
              title: item.noticeTitle,
              content: item.subtitle,
              cover: item.pic || '',
              editTime: item.publishTime || new Date().toISOString()
            }
          })
        }

        selectedNews.value = newsList.value[0]

      } catch (error) {
        console.error('获取新闻失败:', error);
        // 使用降级数据
        newsList.value = [];
      } finally {
        isLoading.value = false;
      }
    };

    const selectedNews = ref(null); // 默认选中第一篇新闻
    const oldSelect = ref(true);
    const newSelectTime = ref(null);

    const changeMainNews = (newsItem) => {
      console.log("进来了。。。。")
      oldSelect.value = false;
      if (!oldSelect.value)
        newSelectTime.value = setTimeout(() => {
          oldSelect.value = true;
          clearTimeout(newSelectTime.value)
        }
          , 500);
      selectedNews.value = newsItem;
    };

    // 页面导航
    const navigateTo = (path) => {
      router.push(path);
    };

    // 查看新闻详情
    const viewNewsDetail = (id) => {
      router.push(`/news/${id}`);
    };

    // 播放视频
    const playVideo = () => {
      // 这里可以实现视频播放逻辑，如弹出视频播放器模态框
      alert('播放公司宣传视频');
    };

    onMounted(() => {
      fetchAdvertise();
      fetchHomeCate();
      fetchAlbum();
      fetchNews();
    });

    return {
      carouselSlides,
      businessAreas,
      activeIndex,
      newsList,
      isLoading,
      currentTime,
      formatDate,
      getSummary,
      navigateTo,
      viewNewsDetail,
      playVideo,
      statisticsData,
      statisticsLoading,
      images,
      selectedNews,
      oldSelect,
      changeMainNews,
    };
  }
}
</script>

<style lang="scss" scoped>
// 公共标题
.text-group_5 {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(34, 34, 34, 1);
    font-size: 40px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    white-space: nowrap;
    line-height: 56px;

    @media (max-width: 1200px) {
      font-size: 32px;
      line-height: 40px;
    }

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .text_9 {
    color: rgba(204, 204, 204, 1);
    font-size: 14px;
    text-transform: uppercase;
    font-weight: normal;
    white-space: nowrap;
    line-height: 22px;
    margin: 12px 0 0 0;



    @media (max-width: 768px) {
      font-size: 10px;
      line-height: 22px;
    }
  }

  .box_9 {
    width: 400px;
    height: 4px;
    background: linear-gradient(270deg, rgba(37, 240, 64, 0) 0%, #10DD1E 49%, rgba(16, 221, 30, 0) 100%);
    margin: 16px 0 54px 0px;
  }
}


.home-page {
  .hero-section {
    margin-top: 0;
    position: relative;

    .carousel-content {
      height: 100%;
      background-position: center;
      background-size: cover;
      position: relative;

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
      }

      .carousel-caption {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        width: 80%;
        max-width: 800px;
        z-index: 2;

        .slide-subtitle {
          margin-bottom: 15px;
          letter-spacing: 1px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 60px;
          color: #FFFFFF;
          line-height: 84px;
          letter-spacing: 20px;
          font-style: normal;

          @media (max-width: 576px) {
            font-size: 32px;
          }
        }

        .slide-title {
          margin-bottom: 30px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 24px;
          letter-spacing: 4px;
          font-style: normal;
          text-transform: uppercase;
        }

        .slide-button {
          padding: 12px 30px;
          font-size: 16px;
          font-weight: 500;
          background-color: #163C7D;
          border-color: #163C7D;

          &:hover {
            background-color: darken(#163C7D, 10%);
            border-color: darken(#163C7D, 10%);
          }
        }
      }
    }
  }

  .business-video {
    margin-top: 20px;
    background-color: #FFFFFF;

    .bvideos {
      margin: 0 auto;
      padding: 0 20px;
      width: 1500px;
      overflow: hidden;
      border-radius: 7px;
      height: 500px !important;

      video {
        width: 100%;
        height: 100%;
        border-radius: 7px;
        object-fit: cover;
      }
    }
  }

  .business-areas {

    padding: 60px 0;
    background-color: #FFFFFF;

    .business-grid {

      // grid-template-columns: repeat(4, 1fr);
      //grid-template-columns: 500px repeat(3, 1fr);
      width: 100%;
      display: flex;


      @media (max-width: 1200px) {
        display: grid;
        gap: 30px;
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        display: grid;
        gap: 30px;
        grid-template-columns: 1fr;
      }

      .business-card {
        min-width: 200px;
        width: 20%;
        height: 540px;
        margin-left: 32px;

        &:first-child {
          margin-left: 0px;
        }

        .business-icon {
          position: absolute;
          bottom: 0;
          right: -150px;
        }

        @media (max-width: 1200px) {
          min-width: 0px;
          width: 100%;
          height: 300px;
          margin-left: 0;
          position: relative;
          z-index: 2;

          .business-icon {
            z-index: -1;
            position: absolute;
            bottom: 0;
            right: 0;

            img {
              width: 60%;
            }
          }
        }


        background: linear-gradient(180deg, #041F0C 30%, #000000 70%);
        padding: 40px 30px;
        border-radius: 32px;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        cursor: pointer;

        &.active {
          transform: translateY (-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          min-width: 488px;
          width: 40%;
          transition: all 1s ease;

          @media (max-width: 1200px) {
            min-width: 0px;
            width: 100%;
            transform: translateY (0);
          }

          .business-hover {
            bottom: 0;
          }

          h3,
          p {
            text-align: left;
          }

          .business-icon {
            right: 0;
          }
        }

        h3 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #FFFFFF;
          line-height: 45px;
          font-style: normal;
        }

        p {
          font-size: 16px;
          color: #fbf8f8;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .business-hover {
          position: absolute;
          bottom: -50px;
          left: 0;
          width: 100%;
          color: white;
          padding: 12px 0;
          transition: all 0.3s ease;
          font-weight: 500;

        }
      }
    }
  }

  .news-section {
    padding: 80px 0 40px 0;
    background: #FFFFFF;

    .section-header {
      text-align: center;
      margin-bottom: 50px;

      .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #163C7D;
        position: relative;
        display: inline-block;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -15px;
          width: 60px;
          height: 3px;
          background-color: #163C7D;
          transform: translateX(-50%);
        }
      }
    }

    .news-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 30px;
      margin-bottom: 40px;
      overflow: hidden;
      padding: 10px;

      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }

      .main-news {
        transform: translateY(110%);
        transition: all 0.3s ease;

        @media (max-width: 992px) {
          transform: translateX(110%);
        }

        /* 左侧新闻切换动画 */
        &.slide-in {
          transform: translateY(0);

          @media (max-width: 992px) {
            transform: translateX(0);
          }
        }


        .main-news-item {
          background-color: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.5);
          }

          .news-image {
            height: 300px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.5s ease;

              &:hover {
                transform: scale(1.05);
              }
            }
          }

          .news-info {
            padding: 30px;

            h3 {
              font-size: 22px;
              font-weight: 600;
              color: #333;
              margin-bottom: 15px;
              line-height: 1.4;
            }

            p {
              font-size: 15px;
              color: #666;
              margin-bottom: 20px;
              line-height: 1.6;
            }

            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-top: 15px;

              .date {
                color: #999;
                font-size: 14px;
              }

              .read-more {
                color: #163C7D;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
              }
            }
          }
        }
      }

      .sub-news {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .sub-news-item {
          background-color: white;
          border-radius: 8px;
          padding: 25px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateX(5px);
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
          }

          .news-info {
            h3 {
              font-size: 18px;
              font-weight: 600;
              color: #333;
              margin-bottom: 15px;
              line-height: 1.4;

              // 两行文本溢出省略
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .date {
                color: #999;
                font-size: 14px;
              }

              .read-more {
                color: #163C7D;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
              }
            }
          }
        }
      }
    }

    .news-more {
      text-align: center;

      .more-link {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #163C7D;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        padding: 10px 20px;
        border: 1px solid #163C7D;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
          background-color: #163C7D;
          color: white;
        }
      }
    }
  }

  .video-section {
    padding: 80px 0;
    background-color: #f5f5f5;

    .video-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 50px;
      align-items: center;

      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }

      .video-text {
        h2 {
          font-size: 36px;
          font-weight: 700;
          color: #163C7D;
          margin-bottom: 20px;
          line-height: 1.3;
        }

        p {
          font-size: 16px;
          color: #666;
          margin-bottom: 30px;
          line-height: 1.7;
        }

        .video-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #163C7D;
          font-size: 16px;
          font-weight: 500;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .video-player {
        .video-placeholder {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          cursor: pointer;

          img {
            width: 100%;
            height: 350px;
            object-fit: cover;
          }

          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80px;
            height: 80px;
            background-color: rgba(22, 60, 125, 0.8);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            i {
              font-size: 40px;
              color: white;
            }

            &:hover {
              background-color: rgba(22, 60, 125, 1);
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
      }
    }
  }

  //画册
  .statistics-section {

    padding: 80px 0 0 0;

    @media (max-width: 1200px) {
      padding: 50px 0 0 0;
    }

    .hua-top {
      width: 100%;
      height: 150px;
      background: url('@/assets/images/home/picimags_top.png');
      background-size: 100% 100%;
      //background-size: cover;
      //background-position: center center;
      background-repeat: no-repeat;

      @media (max-width: 1200px) {
        height: 150px;
      }

      @media (max-width: 768px) {
        height: 50px;
      }
    }

    .carousel-container {
      background: linear-gradient(180deg, #041F0C 0%, #000000 100%);
      width: 100%; // 设置画册容器宽度
      overflow: hidden;
      position: relative;
      height: 800px;

      @media (max-width: 576px) {
        height: calc(840px / 2);
      }

      .carousel-wrapper {
        display: flex;
        animation: moveCarousel 40s linear infinite; // 动画循环
      }

      .carousel-item {
        flex-shrink: 0;
        width: 680px; // 设置每个图片的宽度
        height: 510px; // 设置每个图片的高度
        margin-right: 32px;
        position: relative;
        left: 0;

        @media (max-width: 576px) {
          width: calc(680px / 2); // 设置每个图片的宽度
          height: calc(510px / 2); // 设置每个图片的高度
        }

        .item0 {
          width: 400px;
          height: 300px;
          top: -30px;
          left: 0;
          position: absolute;

          @media (max-width: 576px) {
            top: calc(-30px / 2);
            width: calc(400px / 2);
            height: calc(300px / 2);
          }
        }

        .item1 {
          width: 300px;
          height: 225px;
          right: 0;
          top: 285px;
          position: absolute;

          @media (max-width: 576px) {
            top: calc(285px / 2);
            width: calc(300px / 2);
            height: calc(225px / 2);
          }
        }

        &.item2,
        &.item5 {
          width: 680px;
          height: 510px;

          @media (max-width: 576px) {
            width: calc(680px / 2);
            height: calc(510px / 2);
          }
        }

        .item3 {
          width: 300px;
          height: 225px;
          top: 0px;
          left: 0;
          position: absolute;

          @media (max-width: 576px) {
            width: calc(300px / 2);
            height: calc(225px / 2);
          }
        }

        .item4 {
          width: 400px;
          height: 300px;
          top: 240px;
          right: 0;
          position: absolute;

          @media (max-width: 576px) {
            top: calc(240px / 2);
            width: calc(400px / 2);
            height: calc(300px / 2);
          }
        }
      }



      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 2px dashed #999;
      }

      @keyframes moveCarousel {
        0% {
          transform: translateX(0); // 从初始位置开始
        }

        100% {
          transform: translateX(-5700px); // 总宽度为图片数量 * 图片宽度
        }
      }
    }
  }
}

.text-wrapper_1 {
  height: 72px;
  background: url('@/assets/images/home/home_btn.png');

  background-size: 100% 100%;
  width: 216px;
  // clip-path: polygon(10% 0%,
  //     /* 左上角保留90%宽度 */
  //     100% 0%,
  //     90% 100%,
  //     0% 100%,
  //     0% 100%
  //     /* 左下角保留90%高度 */
  //   );
  border-radius: 10px;
}

.text_7 {
  color: rgba(34, 34, 34, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: right;
}
</style>